<template>
    <v-container fluid class="home-container">
        <v-row>
            <v-col cols="10" offset="1" class="pt-5 text-center">
                <img class="" src="../assets/dog-icon.png" alt="MaikaElev">
                <h1 class="text-center mb-5"><span class="maika-home">Maika</span><span class="elev-home">Elev</span></h1>
                <p>
                    MaikaElev is a free online tool that unifies a bunch of API's to easily serve video contents
                </p>
                <!--form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                    <input type="hidden" name="cmd" value="_donations" />
                    <input type="hidden" name="business" value="martin_prieto88@hotmail.com" />
                    <input type="hidden" name="item_name" value="Donation MaikaElev" />
                    <input type="hidden" name="currency_code" value="USD" />
                    <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                    <img alt="" border="0" src="https://www.paypal.com/en_UY/i/scr/pixel.gif" width="1" height="1" />
                </form-->
                <h4 class="text-center mt-6 ">I'm looking for:</h4>
                <v-row>
                    <v-col col-sm="6" col-xs="12">
                        <v-btn light x-large min-width="200" class="mx-3 my-3" to="/movies"><v-icon class="mr-4">fas fa-film</v-icon>Movies</v-btn>
                    </v-col>
                    <v-col col-sm="6" col-xs="12">
                        <v-btn light x-large min-width="200" class="mx-3 my-3" to="/shows"><v-icon class="mr-4">fas fa-tv</v-icon>TV Shows</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col  col-sm="6" class="random-content" col-xs="12">
                    <h3 class="mb-3">Random Movie <v-btn title="Get Another Movie" v-on:click="getRandomMovie" class="reload-icon" light><v-icon>fas fa-redo</v-icon></v-btn></h3>
                        <div v-if="loadingRandomMovie" >
                            <loading class="mt-10"></loading>
                        </div>
                        <div  v-else>
                            <title-tile
                                    v-if="randomMovie"
                                    v-bind:key="randomMovie.imdb_id"
                                    v-bind:id="randomMovie.imdb_id"
                                    v-bind:image="randomMovie.images.poster"
                                    v-bind:year="randomMovie.year"
                                    v-bind:title="randomMovie.title"
                                    v-bind:rating="randomMovie.rating.percentage*5/100"
                                    v-bind:basePath="'/movie'"
                            >
                            </title-tile>
                        </div>
                    </v-col>
                    <v-col  col-sm="6" class="random-content" col-xs="12">
                        <h3 class="mb-3">Random Tv Show <v-btn title="Get Another Tv Show"  v-on:click="getRandomShow" class="reload-icon" light><v-icon>fas fa-redo</v-icon></v-btn></h3>
                        <div v-if="loadingRandomShow" >
                            <loading class="mt-10"></loading>
                        </div>
                        <div v-else>
                            <title-tile
                                    v-if="randomShow"
                                    v-bind:key="randomShow.imdb_id"
                                    v-bind:id="randomShow.imdb_id"
                                    v-bind:image="randomShow.images.poster"
                                    v-bind:year="randomShow.year"
                                    v-bind:title="randomShow.title"
                                    v-bind:rating="randomShow.rating.percentage*5/100"
                                    v-bind:basePath="'/show'"
                                    v-bind:seasons="randomShow.num_seasons"
                            >
                            </title-tile>
                        </div>
                    </v-col>
                    <iframe class="mt-8 d-block"  data-aa="1301094" src="//acceptable.a-ads.com/1301094?size=Adaptive&background_color=1b1e21&text_color=ffffff&title_color=e2000d&title_hover_color=c7030e&link_color=e2000d&link_hover_color=c7030e" scrolling="no" style="width: 100%; max-height: 100px; height: 100%; border:0px; padding:0; overflow:hidden" allowtransparency="true"></iframe>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<style>
    .maika-home{
        color: #e2000d;
    }

    .home-container{
        background: url('../assets/home-background.jpg') ;
        background-position: center center;
        background-size: cover;
        height: calc(100% + 20px);
        margin-top: -20px;
    }
    .reload-icon{
        min-width: 25px !important;
        padding: 0 !important;
        height: 25px !important;
        margin-top: -3px;
        margin-left: 5px;
    }
    .reload-icon i{
        font-size: 14px !important;
    }
    .random-content{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        text-align: left;
    }
    .home-container   .title-title{
            width: 320px !important;
        }
    .home-container  .title-image{
            width: 320px !important;
            height: 480px !important;
        }
</style>

<script>
    import axios from 'axios';
    import TitleTile from '@/components/TitleTile';
    import Loading from '../components/Loading';

    export default {
        components:{
            TitleTile,
            Loading
        },
        created() {
            document.title = ' - MaikaElev -';
            this.getRandomMovie();
            this.getRandomShow();
        },
        data() {
            return {
                randomMovie: null,
                randomShow: null,
                loadingRandomMovie: false,
                loadingRandomShow: false
            }
        },
        methods: {
            getRandomMovie(){
                var self = this;
                this.loadingRandomMovie = true;
                axios.get('//api.maikaelev.com/popxy/random/movie?r='+new Date().getTime()).then(function (response) {
                    self.randomMovie = response.data;
                    self.loadingRandomMovie = false;
                })
            },
            getRandomShow(){
                var self = this;
                this.loadingRandomShow = true;
                axios.get('//api.maikaelev.com/popxy/random/show?r='+new Date().getTime()).then(function (response) {
                    self.randomShow = response.data;
                    self.loadingRandomShow = false;
                })
            }
        }
    }
</script>